import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { colors } from '@ajaibid/components';

export const styContainer = css`
  height: 100vh;
  width: 100%;
  min-width: 475px;
  background: ${colors.NEUTRAL_1};
  padding: 110px 25px 0;
`;

export const styFlexCenter = css`
  display: flex;
  justify-content: center;
`;

// react-pin-input does not support className
export const styPinInput = {
  width: '80px',
  margin: '0px 8px',
  border: 'none',
  borderBottom: 'solid 4px #67b3ff',
  fontSize: '20px',
  color: colors.NEUTRAL_0,
};

export const styLink = css`
  text-decoration: underline;
  cursor: pointer;
`;

export const stySplashContainer = css`
  height: 100vh;
  width: 100%;
  min-width: 475px;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.AJAIB_BLUE_5};
  opacity: 1;
  text-align: center;
  overflow: auto;
`;

export const FullScreenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: ${colors.NEUTRAL_1};
`;

export const StyledContainer = styled.div`
  width: 600px;
  padding: 32px 24px;
  background-color: ${colors.NEUTRAL_0};
  border-radius: 8px;
`;
